import { Linkedin, Facebook, Instagram } from "lucide-react";

const footerLinks = [
  { label: "Product", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "Terms", href: "/terms" },
  { label: "Privacy", href: "/privacy" },
  { label: "Cookie Settings", href: "/cookie-settings" },
  { label: "Contact", href: "/contact" },
];

const socialLinks = [
  { icon: Instagram, label: "instagram", href: "https://www.instagram.com/adbit.digital/" },
  { icon: Facebook, label: "facebook", href: "https://www.facebook.com/profile.php?id=61570691339014" },
  { icon: Linkedin, label: "linkedin", href: "https://www.linkedin.com/company/adbitdigital/" },
];

export default function FooterSection() {
  return (
    <footer className="py-16 border-t border-slate-200" data-testid="footer">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-10">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src="/adbit-logo.png" alt="AdBit" className="h-8 w-auto" />
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-6">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="text-sm text-slate-500 hover:text-orange-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${social.label}`}
                className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center text-slate-400 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                aria-label={social.label}
              >
                <social.icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-100 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400">
            &copy; 2026 AdBit. All rights reserved.
          </p>
          <p className="text-[10px] text-slate-300 max-w-lg text-center md:text-right leading-relaxed">
            AdBit uses predictive models based on computational neuroscience. Results are predictions, not guarantees of performance.
          </p>
        </div>
      </div>
    </footer>
  );
}
